import React from 'react';

export default function NavItem({ name, handleMode, active }) {
    return (
        <div
            className={`account-item ${active === name ? 'active' : ''}`}
            onClick={() => handleMode(name)}
        >
            {name}
        </div>
    );
}
